import { useContext } from 'react';
import { CampaignMetadataContext } from 'src/contexts/CampaignMetadataContext';

export const useCampaignMetadata = () => {
  const context = useContext(CampaignMetadataContext);
  if (!context) {
    throw new Error('useCampaignMetadata must be used within a CampaignMetadataContextProvider');
  }
  return context;
};
